import { atom } from 'recoil';
import { ProductCategory } from '../interfaces/Product';

export interface ProductCategoriesListType {
  list: ProductCategory[] | null;
}

export const ProductCategoriesListState = atom<ProductCategoriesListType>({
  key: 'ProductCategoriesListState',
  default: {
    list: null,
  },
});
